export default __webpack_public_path__ + "static/media/incomingmessage.0eb318b7.wav";